/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вызов редьюсеров для связи с react-redux.
   * @param {Object} reduxStore Ссылка на store.
   * @param {String} jsView Идентификатор текущей страницы.
   */
  app.ReduxDispatchesView = app.View.extend({
    /** @inheritDoc */
    additionalOptions: ['jsView'],

    /** @inheritDoc */
    run: function () {
      this.listenTo(this.settlement, 'sync', this._onSettlementChange);
    },

    /**
     * Вызов редьюсера в store.
     * @param type
     * @param data
     */
    dispatch: function (type, data) {
      app.reduxStore.dispatch(_.merge({ type: type }, data));
    },

    /**
     * Вызов редьюсера после обновления формы поселения
     * в зависимости от текущей страницы.
     * @private
     */
    _onSettlementChange: function () {
      if (app.reduxStore) {
        switch (this.jsView) {
          case 'joint-purchase-control':
            this._updateMinOrderSum(this.settlement.get('min_order_sum'));
            break;
          case 'reactive-checkout':
            this._updateCurrentSettlement(this.settlement.toJSON());
            break;
          case 'react-delivery':
              this._fullUpdateCurrentSettlement(this.settlement.toJSON());
            break;
        }
      }
    },

    /**
     * Изменяем минимальную сумму заказа в redux store
     * @param {Number} minsum Минимальная сумма заказа.
     * @private
     */
    _updateMinOrderSum: function (minsum) {
      this.dispatch(
        'USER_UPDATE_DATA',
        { data: {
            min_order_sum: minsum,
          },
        });
    },

    /**
     * Отправляет все данные поселения в redux store.
     * @param {Object} settlement Объект с данными поселения.
     * @private
     */
    _fullUpdateCurrentSettlement: function (settlement) {
      this.dispatch(
        'settlement/CHANGE_SETTLEMENT',
        { settlement: settlement }
      );
    },

    /**
     * Устанавливаем город в redux store.
     * @param {Object} settlement Объект с данными города.
     * @private
     */
    _updateCurrentSettlement: function (settlement) {
      this.dispatch(
        'settlement/SETTLEMENT_IS_SAVED',
        { id: settlement.settlement_id }
      );
    },
  });
})();


}.call(window));